import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions
} from 'chart.js';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface Bin {
  range: string;
  num_users: number;
}

interface BinsChartProps {
  bins: Bin[];
}

const colors = [
  '#FFCC04',
  '#FFE066',
  '#4A4008',
  '#CCCCCC',
  '#999999',
  '#666666',
  '#000000'
];

const BinsChart: React.FC<BinsChartProps> = ({ bins }) => {
  const total = bins.reduce((sum, bin) => sum + bin.num_users, 0);
  const data = {
    labels: bins.map(bin => bin.range),
    datasets: [
      {
        label: 'Usuários',
        data: bins.map(bin => bin.num_users),
        backgroundColor: colors,
        borderColor: '#222',
        borderWidth: 2,
        borderRadius: 8,
        barPercentage: 0.7,
        categoryPercentage: 0.7
      }
    ]
  };

  const options: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: '#fff',
        titleColor: '#000',
        bodyColor: '#000',
        borderColor: '#ddd',
        borderWidth: 1,
        padding: 12,
        callbacks: {
          label: (context) => `Usuários: ${context.parsed.y.toLocaleString('pt-BR')}`
        }
      },
      title: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          font: {
            size: 14
          },
          color: '#222'
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: '#e5e5e5'
        },
        ticks: {
          font: {
            size: 14
          },
          color: '#222',
          callback: (value) => value.toLocaleString('pt-BR')
        }
      }
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="dark:text-white">Distribuição de Streaks por Usuário</CardTitle>
        <div className="mt-2 text-lg font-semibold text-pink-600 dark:text-pink-400">
          Total de usuários: {total.toLocaleString('pt-BR')}
        </div>
      </CardHeader>
      <CardContent>
        <div style={{ height: 320 }}>
          <Bar data={data} options={options} />
        </div>
        <div className="text-xs text-gray-500 mt-2">
          Cada faixa representa a quantidade de usuários com streaks dentro daquele intervalo de dias.
        </div>
      </CardContent>
    </Card>
  );
};

export default BinsChart; 